module.exports = require('./helpers/bundle-url').getBundleURL('84S4Y') + "compass-banner.9eb9b2c9.svg";